import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Menu
 */

export default function MenuIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M1 5C1.55228 5 2 4.55228 2 4C2 3.44772 1.55228 3 1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5ZM4 4C4 3.44772 4.44772 3 5 3H15C15.5523 3 16 3.44772 16 4C16 4.55228 15.5523 5 15 5H5C4.44771 5 4 4.55228 4 4ZM5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44771 9 5 9H15C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7H5ZM5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H5ZM2 8C2 8.55228 1.55228 9 1 9C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7C1.55228 7 2 7.44772 2 8ZM1 13C1.55228 13 2 12.5523 2 12C2 11.4477 1.55228 11 1 11C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
